import Config from '../Config';
import { RestService } from './RestService';

export const JobStatusTransactionService = {
    getJobStatusTransactions: async function(start, numberItems, startdate, enddate, project_id, job_action_id, user_id, sort, direction){
        return RestService.get(`${Config.get_job_status_transactions}from=${start}&offset=${numberItems}&sort=${sort}&direction=${direction}${ project_id ? `&project_id=${project_id}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}${ user_id ? `&user_id=${user_id}` : ''}${ job_action_id ? `&job_action_id=${job_action_id}` : ''}`, {})
        .then(response => response.json());
    },
    getTotalCount: async function(project_id, startdate, enddate) {
        return RestService.get(`${Config.total_count}data_type=JOB_STATUS_TRANSACTIONS${ project_id ? `&project_id=${project_id}` : ''}${ startdate ? `&startdate=${startdate}` : ''}${ enddate ? `&enddate=${enddate}` : ''}`, {})
        .then(response => response.json());
    },
    createTransaction: async function(headers, body){
        return RestService.post(`${Config.create_job_status_transaction}`, headers, body);
        // .then(response => response.json());
    },
    getJobStatusTransactionsForProject: async function(id) {
        return RestService.get(`${Config.get_project_job_status_transactions}id=${id}`, {})
        .then(response => response.json());
    },
    // changeProjectStatus: async function(headers, body){
    //     return RestService.post(`${Config.change_project_status}`, headers, body);
    //     // .then(response => response.json());
    // },
};